import { useCallback } from "react"
import { logOut } from "state/authSlice"
import { useDispatch } from "react-redux"
import { api } from "state/api"
import { unsubscribeFromPush } from "../../pwa/pushClient"
import {
  activateAccount,
  forgetAccount,
  readSavedAccounts,
} from "state/savedAccounts"

export const useLogout = () => {
  const dispatch = useDispatch()

  const logout = useCallback(async () => {
    let stored = null
    try {
      stored = JSON.parse(localStorage.getItem("user") || "null")
    } catch (_) {
      /* corrupt — treat as signed out */
    }

    // Tear down the push subscription on this device BEFORE clearing auth,
    // so the server-side DELETE /push/subscribe request still has a valid
    // Bearer token. Wrapped in try/catch — logout must never fail because of
    // a missing SW, offline network, or dead subscription. On a phone with
    // several accounts the server drops only THIS account from the phone;
    // the others keep their notifications.
    try {
      await unsubscribeFromPush(stored && stored.token)
    } catch (_) {
      /* ignore — continue with logout */
    }

    // This account leaves the device. If another one is still signed in
    // here, open it instead of the sign-in page (like Instagram).
    const leaving = stored?.user?._id || null
    forgetAccount(leaving)
    const next = readSavedAccounts().find(
      (a) => String(a.user._id) !== String(leaving)
    )
    if (next) {
      activateAccount(dispatch, next, { resetApi: api.util.resetApiState })
      return
    }

    // remove user from storage
    localStorage.removeItem("user")

    // dispatch logout action
    dispatch(logOut())

    // Drop every cached RTK Query response. Cache keys aren't user-scoped,
    // so without this the next login on the same device could read the
    // previous user's cached results (e.g. a palette phone search) for up
    // to keepUnusedDataFor seconds.
    dispatch(api.util.resetApiState())
  }, [dispatch])

  return { logout }
}
